// extracted by mini-css-extract-plugin
export default {"select":"SelectMenu_select__B7a9J"};